let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4E4zv")).then(() => parcelRequire('bhy5u'));